import { List, Typography } from '@material-ui/core';
// import { AssociadoTransmissaoRoutePath } from 'library/Routes';
import React /* , {  useCallback, useMemo } */ from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from 'store/Reducer';
import useStyle from './styles';
import { dispatchToAllYouTubeVideos } from 'helpers/utils/HTMLUtils';
import { VideoPlayer } from 'plataforma-fundacao-componentes';

export default function AssembleiaVideos() {
  const classes = useStyle();
  const { currentEvent } = useSelector((state: IReducer) => state.assembleias);

  return (
    <List component='nav' aria-label='main videobox list'>
      {currentEvent?.videos.map((item) => {
        return (
          <>
            <div className={classes.card} key={item.oidVideo}>
              {/* <Player
                id={crypto.randomUUID()}
                key={crypto.randomUUID()}
                url={item.urlYoutube}
                disabledMinimize
                callBackStarted={(id) => {
                  dispatchToAllYouTubeVideos('pauseVideo', id);
                }}
              /> */}
              <VideoPlayer
                id={crypto.randomUUID()}
                key={crypto.randomUUID()}
                blockRedirect={true}
                url={item.urlYoutube}
                callBackStarted={(id) => {
                  dispatchToAllYouTubeVideos('pauseVideo', id);
                }}
              />
              <Typography component='p'>{item.descricao}</Typography>
            </div>
          </>
        );
      })}
    </List>
  );
}
